export const CREATE_NEW_TOAST           = 'CREATE_NEW_TOAST';
export const CREATE_NEW_MODAL           = 'CREATE_NEW_MODAL';
export const REMOVE_TOAST               = 'REMOVE_TOAST';
export const REMOVE_MODAL               = 'REMOVE_MODAL';